import { AxiosInstance } from "axios"

export enum DeadlineMessageQuery {
    DELIVERY_DEADLINE_MESSAGE = "delivery-deadline-message",
}

type DeadlineMessageParam = Readonly<{
    merchantId: number
    deliveryTime: string
    productWish?: boolean
    shopId: number
    priceListId: number
}>

export type DeadlineMessageInfo = Readonly<{
    displayRule: string
    merchantMessage: string
    title: string
}>

export type DeadlineMessageResponse = Readonly<{
    deadlineMessage: {
        isConfirmed: boolean
        message: DeadlineMessageInfo
    }
}>

export async function fetchDeadlineMessage(
    { merchantId, ...rest }: DeadlineMessageParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<DeadlineMessageResponse> {
    const url = `merchants/${merchantId}/orders/deadlineMessage`
    const { data } = await axios.get(url, {
        signal,
        params: rest,
    })

    return data
}
